export default "__VITE_ASSET__COtfXkID__"